import {Cell} from "react-table";
import {FormattedMessage} from "react-intl";
import React from "react";
import {ListingCriteriaScore} from "../../../../types/types";

/**
 * Rendert die "Bewertung"-Tabellen-Zelle für das Einreichungslisting
 *
 * @param cell
 * @constructor
 */
const ReviewsColumn: (cell: Cell) => JSX.Element = (cell: Cell) => {

    /**
     * Gibt die Bewertung einer Einreichung zurück
     */
    const displayReviews = () => {
        // Fall "Bewerung abgelehnt"
        if (cell.row.values.review.reasoning) {
            return (
                <>
                    <b>
                        <i className='fa fa-times'/>
                        <FormattedMessage id="myarea.listing.column.body.review.declined"/>
                    </b>
                    {cell.row.values.review.reasoning}
                </>
            );
        }

        // Fall "noch nicht bewertet"
        if (!cell.row.values.review.criteriaScores || cell.row.values.review.criteriaScores.length === 0) {
            return (
                <b>
                    <i className='fa fa-circle-o'/>
                    <FormattedMessage id="myarea.listing.column.body.review.missing"/>
                </b>
            );
        }

        // Fall "Einreichung bewertet"
        return (
            <>
                {cell.row.values.review.criteriaScores.map((score: ListingCriteriaScore) => {
                    if (!score) {
                        return null;
                    }

                    return (
                        <p key={score.criterium}>
                            <b>{score.criterium}:</b> {
                            score.score !== null
                                ? (
                                    score?.score > 0
                                        ? score.score
                                        : <FormattedMessage id="submission.review.scoring.no_decision"/>
                                )
                                : <FormattedMessage id="myarea.listing.column.body.review.score.noDecision"/>
                        }
                        </p>
                    );
                })}
            </>
        )
    }

    return (
        <span>
            {displayReviews()}
        </span>
    );
}

export default ReviewsColumn;
